import React, { useEffect, useState } from "react";
import "../styles/MyReviewsPage.css"; // ✅ 새로운 스타일 적용
import MyPageSidebar from "./MyPageSidebar";
import MyPageEmpty from "./MyPageEmpty";
import MyReviewsSection from "./MyReviewsSection"; // ✅ 새로운 컴포넌트

const MyReviewsPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [myReviews, setMyReviews] = useState([]);

    useEffect(() => {
        // 내가 작성한 리뷰 데이터 연동
        const fetchMyReviews = async () => {
            try {
                const response = await fetch("/api/mypage/reviews"); // ✅ 실제 API 호출
                if (response.ok) {
                    const data = await response.json();
                    setMyReviews(data.myReviewData !== "noData" ? data.myReviewData : []);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMyReviews();
    }, []);

    if (isLoading) <p>로딩중...</p>;

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-review-available-list-container">
                <h2 className="mypage-title">내가 작성한 리뷰</h2>
                <MyReviewsSection myReviews={myReviews} />
            </div>
        </div>
    );
};

export default MyReviewsPage;
